import { Reducer } from "redux";
import { Action, ActionType } from "../actionTypes/finalScheduleActionTypes";

export interface IFinalScheduleState {
  finalScheduleDetailsByPID: any[];
}

const initialState = {
  finalScheduleDetailsByPID: [],
};

export interface Iheaders {
  headName: string;
  value: string;
  classname?: string;
  separator?: string;
}
export interface ITableData {
  headers: Iheaders[];
  tableData: any;
  totalObject: Record<string, any>[];
}

export const finalScheduleReducer: Reducer<IFinalScheduleState, Action> = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.FINAL_SCHEDULE_DETAILS_BY_PID:
      return {
        ...state,
        finalScheduleDetailsByPID: action.payload,
      };
    default:
      return state;
  }
};
